import router from '@/router/index'
import store from '@/store/index'
const whiteList = ['/home'] // no redirect whitelist
router.beforeEach(function(to, from, next) {
	const hasToken = store.getters.token
	const hasInfo = store.getters.hasInfo
	store.dispatch('app/clearPromise')
	if (hasToken) {
		if (!hasInfo) {
			store.dispatch('user/getUserInfo')
		}
		next()
	} else {
		if (whiteList.includes(to.path)) {
			next()
		} else {
			next()
			window.location.href =
				`${process.env.VUE_APP_API_DOMAIN}/login?redirect=${process.env.VUE_APP_INDEX_DOMAIN}/${encodeURIComponent('expressIndex'+to.fullPath)}`
		}
	}
})
